var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icons/linkedin",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "LinkedinLogo",
  transform: "translate(2.037500, 1.700000)",
  fill: "#009877",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.3544304,0 L1.64556962,0 C0.759493671,0 -1.12427648e-15,0.759493671 -1.12427648e-15,1.64556962 L-1.12427648e-15,18.3544304 C-1.12427648e-15,19.2405063 0.759493671,20 1.64556962,20 L18.3544304,20 C19.2405063,20 20,19.2405063 20,18.3544304 L20,1.64556962 C20,0.759493671 19.2405063,0 18.3544304,0 Z M18.3544304,18.3544304 L1.64556962,18.3544304 L1.64556962,1.64556962 L18.3544304,1.64556962 L18.3544304,1.64556962 L18.3544304,18.3544304 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.82278481,7.46835443 C5.3164557,7.46835443 5.06329114,7.84810127 5.06329114,8.2278481 L5.06329114,14.9367089 C5.06329114,15.443038 5.44303797,15.6962025 5.82278481,15.6962025 C6.20253165,15.6962025 6.58227848,15.3164557 6.58227848,14.9367089 L6.58227848,8.2278481 C6.70886076,7.84810127 6.32911392,7.46835443 5.82278481,7.46835443 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10,8.2278481 C10,7.84810127 9.62025316,7.59493671 9.24050633,7.59493671 C8.73417722,7.59493671 8.48101266,7.97468354 8.48101266,8.35443038 L8.48101266,15.0632911 C8.48101266,15.5696203 8.86075949,15.8227848 9.24050633,15.8227848 C9.62025316,15.8227848 10,15.443038 10,15.0632911 L10,11.2658228 C10,10.7594937 10.2531646,10.1265823 10.6329114,9.74683544 C11.3924051,8.98734177 12.7848101,8.98734177 13.6708861,9.74683544 C14.0506329,10.1265823 14.3037975,10.6329114 14.3037975,11.2658228 L14.3037975,15.0632911 C14.3037975,15.5696203 14.6835443,15.8227848 15.0632911,15.8227848 C15.443038,15.8227848 15.8227848,15.443038 15.8227848,15.0632911 L15.8227848,11.2658228 C15.8227848,10.2531646 15.443038,9.36708861 14.6835443,8.60759494 C13.5443038,7.34177215 11.3924051,7.21518987 10,8.2278481 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 5.82278481,
  cy: 4.93670886,
  r: 1.01265823
})))));
export { SvgLinkedin as ReactComponent };
export default __webpack_public_path__ + "images/linkedin.svg";